export default __webpack_public_path__ + "static/media/m.0d629d8c.svg";